import { Component, OnInit, Input, Inject } from '@angular/core';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { APP_CONFIG } from '../../api/config';
import { getSupportedBPGLogos } from '../../common';
import { getBpgURL } from '../../common';
import { Hotel } from '../../api/model/hotel/hotel.model';
import { Brands } from '../../api/enums/brands.enum';

@Component({
  selector: 'stay-mgmt-bpg-image',
  templateUrl: './bpg-image.component.html',
  styleUrls: ['./bpg-image.component.scss']
})
export class BpgImageComponent implements OnInit {
  displayLogo = false;
  bpgImageLink: string;
  bpgImagePath: string;
  appConfig: IAppConfig;


  constructor(@Inject(APP_CONFIG) appConfig: IAppConfig) {
    this.appConfig = appConfig;
  }

  ngOnInit() {
    this.bpgImageLink = getBpgURL(this.appConfig);
    this.bpgImagePath = this.getBpgImageForLocale();
  }

  @Input()
  set hotel(hotel: Hotel) {
    this.displayLogo = hotel && !hotel.isInGreaterChina() && Brands.PAL !== this.appConfig.brand.brandCode && Brands.VOCO !== this.appConfig.brand.brandCode && Brands.REGENT !== this.appConfig.brand.brandCode;
  }

  getBpgImageForLocale() {
    const { language, country, defaultCountry, defaultLanguage } = this.appConfig;
    const localeString = ((language && country) ? `${language}-${country}` : `${defaultLanguage}-${defaultCountry}`).toLowerCase();

    if (getSupportedBPGLogos().indexOf(localeString) > -1) {
      return this.appConfig.bpgImage.imagePath + 'bpg-' + localeString + '-grey.svg';
    } else {
      return this.appConfig.bpgImage.imagePath + 'bpg-grey.svg';
    }
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/bpg-image/bpg-image.component.ts